// extracted by mini-css-extract-plugin
export default {"Card":"TokensStatisticsCard_Card__a29Ir","Top":"TokensStatisticsCard_Top__dqtwz"};